import styled from 'styled-components'
export const Wrapper = styled.div`
  .clientId {
    min-width: 90px;
  }
  .actionName {
    min-width: 180px;
  }
`
